import { remember, serializeDataToCacheKey } from '@tuic/cache';
import { logger } from '@tuic/logger';

import { CacheTag, Oss } from '../../index';

import type { Locale } from '@tuic/i18n';

export async function getEventsBaseData(locale: Locale) {
  const { data, error } = await Oss.getEventsBaseData({
    query: {
      locale,
    },
  });

  if (error) {
    logger.error(`Could not fetch events base data for locale: ${locale}`);
    logger.error(error);

    return undefined;
  }

  return data;
}

export const cachedGetEventsBaseData = (locale: Locale) => {
  return remember(
    serializeDataToCacheKey([CacheTag.oss, 'getEventsBaseData', locale]),
    () => getEventsBaseData(locale),
    {
      tags: [CacheTag.oss, 'getEventsBaseData'],
      ttl: 600,
    },
  );
};
